import { render } from "./line-item.vue?vue&type=template&id=4f63ae66"
import script from "./line-item.vue?vue&type=script&lang=js"
export * from "./line-item.vue?vue&type=script&lang=js"

import "./line-item.vue?vue&type=style&index=0&id=4f63ae66&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__